import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const LinkButton = dynamic(() => import('./LinkButton').then((m) => ({ default: m.LinkButton })));

const LinkButtonConfig = {
  name: 'LinkButton',
  inputs: [
    {
      name: 'externalLink',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Opens link in new tab.',
    },
    {
      name: 'link',
      type: 'string',
    },
    {
      name: 'label',
      type: 'string',
    },
    {
      name: 'size',
      type: 'enum',
      defaultValue: 'medium',
      enum: [
        {
          label: 'small',
          value: 'small',
        },
        {
          label: 'medium',
          value: 'medium',
        },
        {
          label: 'large',
          value: 'large',
        },
      ],
    },
    {
      name: 'variant',
      type: 'enum',
      defaultValue: 'primary',
      enum: [
        {
          label: 'primary',
          value: 'primary',
        },
        {
          label: 'secondary',
          value: 'secondary',
        },
        {
          label: 'tertiary',
          value: 'tertiary',
        },
      ],
    },
    {
      name: 'centered',
      type: 'boolean',
      defaultValue: false,
    },
  ],
};

Builder.registerComponent(LinkButton, LinkButtonConfig);
